import React from 'react';
import PropTypes from 'prop-types';
import { Query } from '@apollo/client/react/components';
import { Grid } from '@material-ui/core';
import capitalize from 'lodash/capitalize';
import MUISelect from './MUISelect';
import { thirdPartyLoginOptions } from './util';
import { GET_CONNECTIONS } from './queries';

const getFdsAccounts = data =>
  data?.client?.financialConnections?.flatMap(connection =>
    connection.accounts.map(account => ({
      ...account,
      institution: {
        name: connection.financialInstitutionName,
        source: connection.source,
      },
    })),
  );

const getIntegrationOptions = fdsAccounts =>
  fdsAccounts?.map(option => {
    const label = `${option.institution.name} - ${option.name} - ${option.number} (${capitalize(
      option.institution.source,
    )})`;
    return { label, id: option.id };
  });

const SplitLedgerCollectionMethods = ({ clientId, toDate, formValues, onChange }) => (
  <Grid container>
    <Query query={GET_CONNECTIONS} variables={{ clientId: clientId.toString(), toDate }}>
      {({ data, loading }) => {
        const fdsAccounts = getFdsAccounts(data);
        const integrationOptions = [{ id: null, label: 'None' }].concat(
          getIntegrationOptions(fdsAccounts) || [],
        );

        return (
          <>
            <Grid item xs={4}>
              <MUISelect
                id="integration"
                name="integration"
                label="Integration"
                placeholder="Select integration"
                value={formValues.integration}
                onChange={onChange}
                options={integrationOptions}
                loading={loading}
                inputDataTestId="integration-input"
              />
            </Grid>
          </>
        );
      }}
    </Query>

    <Grid item xs={4}>
      <MUISelect
        id="thirdPartyLoginAvailable"
        name="thirdPartyLoginAvailable"
        label="Third Party Login"
        value={formValues.thirdPartyLoginAvailable}
        onChange={onChange}
        options={thirdPartyLoginOptions}
        placeholder="Select status"
      />
    </Grid>
  </Grid>
);

SplitLedgerCollectionMethods.propTypes = {
  clientId: PropTypes.number.isRequired,
  toDate: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formValues: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SplitLedgerCollectionMethods;
